import { combineReducers } from "redux"
import applicationReducer from "./application/reducer"
import geoMapReducer from "./geoMap/reducer"
import productReducer from "./product/reducer"
import cartReducer from "./cart/reducer"

const appReducer = combineReducers({
  application: applicationReducer,
  geoMap: geoMapReducer,
  product: productReducer,
  cart: cartReducer
});

export default appReducer;
